import DropdownFilter from "@/components/dropdown_filter.js";
import debounce from "lodash.debounce";
export default function DownloadFilters({searchInput, searchState, searchFunction, currentTab, 
  collection_filters, brand_filters}) {

   const searchBarOptions = {
     searchKeys: {
       companyResources: 'file_name_cont', 
       productAssets: 'document_eq' 
     },
     companyResources: {
       defaultValue: searchState.search["q[file_name_cont]"] || "",
       placeholder: 'Search by File Name', 
     }, 
     productAssets: {
       defaultValue: searchState.search["q[document_eq]"] || "",
       placeholder: 'Search by Product Name', 
     }
   }
 const dropdownOptions = {
     companyResources: {
       searchKey: 'q[tags_id_eq]',
       label: 'Folder Filter' 
     }, 
     productAssets: {
       searchKey: 'q[collections_id_eq]',
       label: 'Product Collections Filter'
     }
   }
 const brandFilterOptions = {
     companyResources: {
       searchKey: 'q[manufacturer_id_eq]',
       label: 'Brand Filter' 
     }, 
     productAssets: {
       searchKey: 'q[manufacturer_id_eq]',
       label: 'Brand Filter'
     }
   }

  const key = currentTab == 'company-resources' ? 'companyResources' : 'productAssets'; 
   const textSearch = debounce((value, searchState) => {
    searchState.addValueAtKey(`q[${searchBarOptions.searchKeys[key]}]`, value);
  }, 200);
  return (
    <>
      <input
        ref={searchInput}
        type="search"
        onKeyUp={(event) => {
          textSearch(event.target.value, searchState);
        }}
        {...searchBarOptions[key]}
        className="lexcms-downloads-search"
      />
      <DropdownFilter
        className="lexcms-downloads-collections-filter"
        searchState={searchState}
        options={collection_filters || []}
        {...dropdownOptions[key]}
      />
      {brand_filters && brand_filters.length > 0  &&
      <DropdownFilter
        className="lexcms-downloads-collections-filter"
        searchState={searchState}
        options={brand_filters || []}
        {...brandFilterOptions[key]}
      />
      }

      <button
        className="lexcms-regular-button lexcms-downloads-clear-search-button"
        onClick={() => {
          searchFunction({});
          searchState.clearAll();
          if (searchInput.current) {
            searchInput.current.value = "";
          }
        }}
      >
        Clear All Results
      </button>
    </>
  )
}
